import { storyblokEditable, renderRichText } from '@storyblok/react'
import { RichTextStoryblok } from '@/component-types-sb'

export default function RichText({ blok }: { blok: RichTextStoryblok }) {
    const content = blok.content
        ? String(renderRichText(blok.content as Parameters<typeof renderRichText>[0]) || '')
        : ''

    if (!content) return null

    return (
        <section {...storyblokEditable(blok)} className={`richText max-w-[1200px] mx-auto ${blok.extraSpacing ? 'px-5 md:px-10 py-15 md:px-25 md:py-20' : 'p-5 md:p-10'} ${blok.noBottomSpacing ? '!pb-0' : ''}`}>
            {blok.heading && <h2 id={blok.heading}>{blok.heading}</h2>}
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: content }}/>
        </section>
    )
} 